import {InferActionsTypes} from '../helpers';
import {IAction} from '../interface';
import {IChatroomDialogue} from './interfaces';

export const SET_CHATROOM_DIALOGUES = 'SET_CHATROOM_DIALOGUES';
export const setChatroomDialogues = (dialogues: IChatroomDialogue[]): IAction<IChatroomDialogue[]> => ({
  type: SET_CHATROOM_DIALOGUES,
  payload: dialogues
});

const chatroomActions = {
  setChatroomDialogues
};

export type ChatroomActionsType = InferActionsTypes<typeof chatroomActions>
